
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/d9",
      function () {
        return require("private-next-pages/products/d9/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/d9"])
      });
    }
  